import { Fragment } from "react";
import {
  Container,
  Image,
  LineContainer,
  NavLink,
  RegisterButton,
} from "./styles/HeaderStyles";
import { useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LoggedInMenu from "../../../../components/LoggedInMenu/LoggedInMenu";
import Notifications from "../../../../components/Notifications/Notifications";
import DrawerMenu from "../../../../components/DrawerMenu/DrawerMenu";
// Logos
import LogoSecondaryWhite from '../../../../assets/images/LogoSecondaryWhite.png'
import LogoSecondaryColor from '../../../../assets/images/MiturLogoSecondary.png'

function Header(props) {
  const matchesWidth = useMediaQuery("(min-width:1000px)");
  const history = useHistory();
  const { authenticated } = useSelector((state) => state.authReducer);
  const location = useLocation();

  // El prop isHero determina el estilo del header.
  // Si no se provee, intentamos inferirlo de la ruta actual.
  const isHero = props.isHero !== undefined ? props.isHero : (location.pathname === '/' || location.pathname === '/public');

  const goToRoute = (route) => {
    history.push(route);
  };

  return (
    <Fragment>
      {matchesWidth ? // Big devices header
        <Container $isHero={isHero}>
          <LineContainer>
            {/* Logo dinámico según el fondo */}
            <div style={{ display: 'flex' }}>
              <Image
                onClick={() => goToRoute("/")}
                src={isHero ? LogoSecondaryWhite : LogoSecondaryColor}
                alt="MITUR Logo"
              />
            </div>

            {/* Menú Principal — Centrado Absoluto */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
              <NavLink
                $isHero={isHero}
                href="#"
                onClick={(e) => { e.preventDefault(); goToRoute('/'); }}
                className={location.pathname === '/' && !location.hash ? 'active' : ''}
              >
                Inicio
              </NavLink>
              <NavLink
                $isHero={isHero}
                href="#"
                onClick={(e) => { e.preventDefault(); goToRoute('/todos-los-tramites'); }}
                className={location.pathname.includes('/todos-los-tramites') || location.pathname.includes('/tramite') ? 'active' : ''}
              >
                Trámites
              </NavLink>
              <NavLink
                $isHero={isHero}
                href="#"
                onClick={(e) => { e.preventDefault(); goToRoute('/base-legal'); }}
                className={location.pathname.includes('/base-legal') ? 'active' : ''}
              >
                Base Legal
              </NavLink>
              <NavLink
                $isHero={isHero}
                href="#"
                onClick={(e) => { e.preventDefault(); goToRoute('/preguntas-frecuentes'); }}
                className={location.pathname.includes('/preguntas-frecuentes') ? 'active' : ''}
              >
                FAQ
              </NavLink>
              <NavLink
                $isHero={isHero}
                href="#"
                onClick={(e) => { e.preventDefault(); goToRoute('/contacto'); }}
                className={location.pathname.includes('/contacto') ? 'active' : ''}
              >
                Contacto
              </NavLink>
            </div>

            {/* Acciones de Autenticación — Derecha */}
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '3rem' }}>
              {!authenticated ? (
                <Fragment>
                  <NavLink
                    $isHero={isHero}
                    href="#"
                    onClick={(e) => { e.preventDefault(); goToRoute('/login'); }}
                    className={location.pathname.includes('/login') ? 'active' : ''}
                  >
                    Iniciar sesión
                  </NavLink>
                  <RegisterButton
                    href="#"
                    onClick={(e) => { e.preventDefault(); goToRoute('/registro'); }}
                  >
                    Regístrate
                  </RegisterButton>
                </Fragment>
              ) : (
                <Fragment>
                  <LoggedInMenu />
                  <Notifications color={isHero ? 'white' : 'black'} />
                </Fragment>
              )}
            </div>
            <div style={{ position: 'relative', height: '100px' }}>
              <mitur-portal-switcher
                variant="absolute"
                top="32px"
                right="0px"
                color="white"
                style={{ color: 'white' }}
              ></mitur-portal-switcher>
            </div>
          </LineContainer>
        </Container>
        :
        // Mobile View
        <Container $isHero={isHero}>
          <LineContainer>
            <Image
              onClick={() => goToRoute("/")}
              src={isHero ? LogoSecondaryWhite : LogoSecondaryColor}
            />
            <DrawerMenu layout="public" />
          </LineContainer>
        </Container>
      }
    </Fragment>
  );
}

export default Header;
